const PREFIX = "@HIGHGROUND_GLOBAL_";

export const USER_DETAIL = `${PREFIX}USER_DETAIL`;
